import { render, staticRenderFns } from "./HistorialMovimientosArmaDialogComponent.vue?vue&type=template&id=33168e2e"
import script from "./HistorialMovimientosArmaDialogComponent.vue?vue&type=script&lang=js"
export * from "./HistorialMovimientosArmaDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports